import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';

export const reqTransform = {
  fetchList(params = {}) {
    let qsParams = Object.fromEntries(Object.entries(params).filter(([_, value]) => value !== null));

    return utils.getQs(qsParams);
  },
  update(params) {
    let bodyParams = {
      ...params,
    };
    return bodyParams;
  },
};

export const resTransform = {
  fetchList(resData) {
    return resData;
  },
  update(resData) {
    return resData;
  },
};
